import { UntypedFormGroup, type ValidatorFn } from '@angular/forms';
import { type BigUntypedFormControl } from './big-form-control';

export class BigUntypedFormGroup extends UntypedFormGroup {
    public rawValidators: ValidatorFn[] = [];
    public isRequired = false;

    public declare controls: Record<string, BigUntypedFormControl | BigUntypedFormGroup>;
}
